export const WORKFLOWS_NAVIGATION_LINKS = [
	{ key: "all-workflows", label: "All Workflows", href: "/company/workflows/" },
	{ key: "all-todos", label: "All To-Dos", href: "/company/workflows/todos-report/" },
];
